export default {
  "authFailed": "Impossible de terminer la configuration du portail",
  "authFailureHelp": "Nous ne pouvions pas restaurer la session du club sécurisé. S'il vous plaît réessayer ou signer à nouveau.",
  "signInAgain": "Signez à nouveau",
  "retry": "Réessayer",
  "restoringAuth": "Restauration de l'authentification...",
  "resolvingOrg": "Résoudre l'organisation...",
  "loadingIdentity": "Chargement de l'identité...",
  "checkingClub": "Voir les détails du club...",
  "clubNotFound": "Club non trouvé",
  "invalidLink": "Le lien que vous avez suivi est invalide.",
  "verifyFailed": "Incapable de vérifier la session",
  "verifyHelp": "Privana n'a pas pu confirmer votre session actuelle de Auth0. S'il vous plaît vous connecter à nouveau pour continuer.",
  "signIn": "Se connecter",
  "close": "Fermer",
  "broadcastResult": "SMS envoyé: {sent} . Failed: {failed} . Skipped: {skipped} .",
  "activeScope": "Joueurs actifs actuellement dans la portée: {count} .",
  "inherit": "Langue du club",
  "saveFailed": "Incapable de Enregistrer la langue. Veuillez réessayer."
};
